  import React from "react";
  import styles from './Showcase.module.css';
  import BlurredTextBox from './BlurredTextBox';

  const WidgetCustomization = ({
    widgetConfig,
    onConfigChange,
    convertRGBAtoHex,
    convertHexToRGBA,
    setShowNotification,
    setNotificationMessage,
    saveSettings
  }) => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
      <div className={styles['widget-customization']}>
      <h3 style={{color: '#FECB00'}}>Widget URL</h3>
        <BlurredTextBox text={"https://dev.super-stream.co/api/showcase/" + localStorage.getItem("_id")} setShowNotification={setShowNotification} setNotificationMessage={setNotificationMessage}></BlurredTextBox>
      </div>  
      <div className={styles["widget-customization"]}>
        <h3 style={{color: '#FECB00'}}>Widget Customization</h3>
        <div className={`styles.button d-flex justify-content-center`}>
          <button onClick={saveSettings} type="button" className={`styles.button d-flex justify-content-center`} style={{marginBottom: '20px'}}>Save</button>
        </div>

        {/* Border Settings */}
        <div className={styles["config-group"]}>
          <h4>Border Settings</h4>
          <label>
            <input
              type="checkbox"
              checked={widgetConfig.showStroke}
              onChange={(e) => onConfigChange("showStroke", e.target.checked)}
              />
            Enable Border
          </label>
          <label>
            Border Color:
            <input
              type="color"
              value={widgetConfig.strokeColor}
              onChange={(e) => onConfigChange("strokeColor", e.target.value)}
              disabled={!widgetConfig.showStroke}
              />
          </label>
          <label>
            Stroke Thickness:
            <input
              type="range"
              min="1"
              max="10"
              step="1"
              value={widgetConfig.strokeThickness || 2}
              onChange={(e) =>
                onConfigChange("strokeThickness", parseInt(e.target.value, 10))
              }
              disabled={!widgetConfig.showStroke}
              />
            <span>{widgetConfig.strokeThickness || 2}px</span>
          </label>
          <label>
            Border Radius:
            <input
              type="range"
              min="0"
              max="30"
              step="1"
              value={widgetConfig.borderRadius}
              onChange={(e) =>
                onConfigChange("borderRadius", parseInt(e.target.value, 10))
              }
              />
            <span>{widgetConfig.borderRadius}px</span>
          </label>
        </div>

        {/* Drop Shadow Settings */}
        <div className={styles["config-group"]}>
          <h4>Drop Shadow Settings</h4>
          <label>
            <input
              type="checkbox"
              checked={widgetConfig.enableShadow || false}
              onChange={(e) => onConfigChange("enableShadow", e.target.checked)}
              />
            Enable Drop Shadow
          </label>
          {widgetConfig.enableShadow && (
            <>
              <label>
                Shadow Color:
                <input
                  type="color"
                  value={widgetConfig.shadowColor || "#000000"}
                  onChange={(e) => onConfigChange("shadowColor", e.target.value)}
                  />
              </label>
              <label>
                Shadow Blur:
                <input
                  type="range"
                  min="0"
                  max="30"
                  step="1"
                  value={widgetConfig.shadowBlur ?? 10} // Handle undefined gracefully
                  onChange={(e) =>
                    onConfigChange("shadowBlur", parseInt(e.target.value, 10))
                  }
                  />
                <span>{widgetConfig.shadowBlur ?? 10}px</span>
              </label>
              <label>
                Shadow Offset X:
                <input
                  type="range"
                  min="-20"
                  max="20"
                  step="1"
                  value={widgetConfig.shadowOffsetX ?? 0} // Handle undefined gracefully
                  onChange={(e) =>
                    onConfigChange("shadowOffsetX", parseInt(e.target.value, 10))
                  }
                  />
                <span>{widgetConfig.shadowOffsetX ?? 0}px</span>
              </label>
              <label>
                Shadow Offset Y:
                <input
                  type="range"
                  min="-20"
                  max="20"
                  step="1"
                  value={widgetConfig.shadowOffsetY ?? 0} // Handle undefined gracefully
                  onChange={(e) =>
                    onConfigChange("shadowOffsetY", parseInt(e.target.value, 10))
                  }
                  />
                <span>{widgetConfig.shadowOffsetY ?? 0}px</span>
              </label>
            </>
          )}
        </div>
        <div className={`styles.button d-flex justify-content-center`}>
          <button onClick={saveSettings} type="button" className={`styles.button d-flex justify-content-center`} style={{marginBottom: '20px'}}>Save</button>
        </div>

      </div>
      </div>
    );
  };

  export default WidgetCustomization;
